module.exports = __webpack_public_path__ + "img/google_sync_updated.79f39784.png";